export default function NotificationIcon(props) {
  const { stroke, ...oRest } = props
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...oRest}
    >
      <path
        d="M10.8309 19H7.16913M14.4926 6.68421C14.4926 5.17666 13.9139 3.73086 12.8839 2.66487C11.8538 1.59887 10.4567 1 9 1C7.54327 1 6.14621 1.59887 5.11615 2.66487C4.08608 3.73086 3.5074 5.17666 3.5074 6.68421C3.5074 9.61175 2.79379 11.6162 1.99663 12.942C1.32421 14.0603 0.987999 14.6195 1.00033 14.7755C1.01398 14.9482 1.04933 15.014 1.18383 15.1173C1.30529 15.2105 1.85284 15.2105 2.94794 15.2105H15.0521C16.1472 15.2105 16.6947 15.2105 16.8162 15.1173C16.9507 15.014 16.986 14.9482 16.9997 14.7755C17.012 14.6195 16.6758 14.0603 16.0034 12.942C15.2062 11.6162 14.4926 9.61175 14.4926 6.68421Z"
        stroke={stroke || "#3B454F"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
